export type VisitKeyLike = {
  id?: string;
  visitDefinitionId?: string;
};

// Planned visits have no `id`, so fall back to `visitDefinitionId` for a stable key.
export const getVisitKey = (visit?: VisitKeyLike) =>
  visit?.id || visit?.visitDefinitionId || '';
